import { render, staticRenderFns } from "./VerifyCodeSender.vue?vue&type=template&id=c52e4e5c&"
import script from "./VerifyCodeSender.vue?vue&type=script&lang=js&"
export * from "./VerifyCodeSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports